import { appNums } from "../nums/app_nums"
const { MIN_PASSWORD_LENGTH } = appNums

export const appStrings = {
    signIn: {
        signIn: "SIGN IN TO YOUR ACCOUNT",
        forgotPassword: "Forgot password?",
    },
    forgotPassword: {
        title: "Send a reset link",
        titleSent: "Reset link sent",
        checkYourEmail: "Almost there. Go check your email!",
        email: "Email",
        button: "RESET PASSWORD",
        buttonSent: "Go to sign in",
    },
    onboarding: {
        optional: "Company Name (optional)",
        signUpTitle: "Nice to meet you!",
        signUpButton: "SIGN UP",
        skip: "Skip for now",
        email: "Email",
        password: "Password",
        placeholder: "Password (at least 8 characters)",
        nameAndPasswordTitle: "Let's finish setting up!",
        iAgree: "I agree to the Shoutbase",
        terms: "Terms of Service",
        and: " & ",
        privacyPolicy: "Privacy Policy",
        companyLabel: "Your company",
        fullNameLabel: "What's your full name?",
        howWould: "How would you like to use Shoutbase?",
        continueButton: "CONTINUE",
        addCompanyNameCompanyNamePlaceholder: "Company Name",
        withMyTeamButton: "WITH MY TEAM OR ORGANIZATION",
        forPersonal: "FOR PERSONAL USE",
        inviteYourTeamTitle: "Invite your team",
        inviteYourTeamButton: "CONTINUE",
        textAreaPlaceholder: "Enter email addresses separated by a comma or new line",
        inviteYourTeamEmail: "Email Address",
        inviteYourTeamFullName: "Full name",
        inviteYourTeamInviteOneByOne: "Invite users one by one",
        fullName: "Full Name (optional)",
        followingAreInvalid: "The following email(s) are invalid: ",
        welcome: "Welcome!",
        signUpConfirmation: {
            welcome: "Great! Check your email for a verification code.",
            send: "Sent to ",
            dash: "-",
            didntReceive: "Didn't receive it? ",
            resend: "Resend code",
            resendInvalid: "Resend valid code to my email",
            codeInvalid: "Code is invalid. ",
        },
        wrongEmail: "Wrong email?",
        alreadyHaveAccount: "Already have an account?",
        signIn: "Sign in",
    },
    addProject: {
        sectionTitle: "Create your first tags",
        buttonText: "CONTINUE",
        sectionDetail: "Shoutbase uses tags to categorize time entries. Name a project or two you're working on and we'll create tags for them now.",
        addAnother: "+ Add another",
        or: "or",
        addMany: "add many at once",
        addOneByOne: "Add tags one by one",
        fieldPlaceholder: "Tag name",
        textAreaPlaceholder: "Enter tags seperated by a comma or new line",
    },
    profileStrings: {
        changeName: {
            nameTitle: "Profile",
            nameDetail: "Displayed in reports, emails, and other places",
            fullName: "Full Name",
        },
        changePassword: {
            passwordTitle: "Change Password",
            passwordDetail: `New passwords must be at least ${MIN_PASSWORD_LENGTH} characters long. Tip: Make it really hard to guess (not password123).`,
            currentPassword: "Current Password",
            newPassword: "New Password",
            confirmNewPassword: "Confirm New Password",
        },
        dateTime: "Time & Date Settings",
        timeZone: "Time Zone",
        dateTimeDetail: "Used in reports.",
        notifications: "Notifications",
        weeklyReportsTitle: "Weekly Reports",
        remindersTitle: "Reminders",
        announcementsTitle: "Future Announcements",
        educationTitle: "New Account Education",
    },
    tutorial: {
        previousButton: "Prev",
        nextButton: "Next",
        doneButton: "Done",
        title: "How Shoutbase Works",
        thanks: "Thanks",
        start: "Start",
        skip: "Skip for now",
        doneMessage: `You can access the help videos any time from the main
        system menu at the upper right corner of the screen.`,
    },
    acceptInviteModal: {
        welcome: "Welcome!",
        hasInvited: "has invited you to track time for",
        onShoutbase: "on Shoutbase.",
        goToTutorial: "Continue to tutorial",
        skip: "Skip it",
        message: "Since you already have a Shoutbase account, you can view the tutorial for a refresher, or skip it and get going!",
    },
    teamEditModal: {
        freeTrialHeader: "Free 30 day trial",
        freeTrialExplanation: "When you create your first team, you will start a free trial for Shoutbase team plan!",
        pricingHeader: "Pricing",
        perUserYear: " per user / year",
        perUserMonth: " per user / month",
        trialUpgradeExplanation: "You may upgrade at any time to continue using teams beyond 30 days!",
        deleteInviteMsg: "Are you sure you want uninvite this user?",
        disableMemberMsg: "Are you sure you want to archive this team member? You will still have access to their team time records.",
        warning: "warning",
        nameAlreadyExists: "A team with this name already exists. Please enter a unique team name.",
        accessLevelOwnMembershipMsg: "You cannot alter your own membership. Please contact another team admin to change your access level.",
        accessLevelIsTeamOwnerMsg: "is the team owner. You cannot alter the team owner's access level.",
    },
    timeEntryModal: {
        alreadyUpdated: "This time entry has been edited since you opened this modal. Saving now would overwrite those changes. Please close and reopen the modal to load the updated entry.",
        confirmDelete: "Are you sure you want to delete this time entry?",
        futureTimeEntries: "Future time entries require an end time.",
    },
    topNav: {
        trialExpired: "Your free trial has ended.",
        leftInTrial: "left in your free trial.",
        upgrade: "Upgrade now!",
        trialExpiresToday: "Your free trial ends today.",
    },
    saveChanges: "Save Changes",
    dashNav: {
        hours: "hours",
        hrs: "hrs",
    },
    connectedApps: {
        keyword: "Keyword",
        keywordsAdded: "Keywords updated",
        keywordTagMatching: "Keyword - Tag Matching",
        addAnother: "+ Add another",
        tagMatchingSubtext: 'Enter keywords from calendar event titles, descriptions, and attendee list you would like to have mapped to Shoutbase tags. For Example: If I have keyword “marketing” mapped to tag “Marketing,” any Google Calendar event with the term “marketing” anywhere in the title or description would be tagged with the “Marketing” tag.',
        attendeeMatching: "Attendee - Shoutbase User Matching",
        attendeeMatchingDescription: "If you or your team members occasionally use a different email address for your Google Calendar events, enter email address and select the corresponding team member below.",
        defaultDescription: "Default Description",
        defaultDescSubtext: "This text will appear in the description of the time records created for your Google Calendar events. (Optional)",
        configUpdated: "Updates saved.",
        connectedCalendars: "Connected Calendars",
        disconnectCalendar: "Disconnect Calendar",
        noCalendars: "You currently have no calendars connected to your team. Add a calendar below to begin automatically creating time records from Google Calendar events.",
        noAccounts: "You currently have no accounts connected to your team. Add an account below to begin automatically creating time records from Google Calendar events",
        disconnectAccount: "Disconnect Account",
        connectedAccounts: "Connected Google Calendar Account:",
        connectAnother: "Connect Another Account",
        connectAccount: "Connect Account",
        cancel: "Cancel",
        edit: "Edit",
        submit: "Submit",
        googleCalendarHeader: "Google Calendar",
        googleCalendarAddNew: "Add New Google Calendar Configuration",
        connectedAppsListHeader: "Connect Apps to Shoutbase",
        connectedAppsSubHeader: "Integrating with other services can help your Shoutbase workflow.",
        connectToGoogle: "Connect to Google",
        accessTokensHeader: "Apps with access to your Shoutbase account",
        accessTokensSubHeader: "These apps have permission to access Shoutbase on your behalf.  If you see any you don't recognize, you may revoke their access here.",
        appName: "App Name",
        publisher: "Publisher",
        accessType: "Access Type",
        revokeAccess: "Revoke Access",
        noTokens: "No Existing Authorizations",
        imagePlaceHolder: "https://via.placeholder.com/30",
        toastMsg: "Are you sure you want to remove this authorization?",
        selectPendingTeam: "Select Team",
        selectTeamDetail: `(1) First, select a team you want to connect to a google calendar.`,
        selectTeamWarning: "Select a team before connecting to Google Calendar.",
        googleCalendarConfigAdded: "Google Calendar Configuration Added",
        googleCalendarAccountAdded: "Google Account Added",
        zoomConfigAdded: "Zoom Account Added",
        accountRemoved: "Google Account Removed",
        accountRemovedToastWarning: "Are you sure you want to remove Google account?",
        calendarRemovedToastWarning: "Are you sure you want to remove Google Calendar?",
        googleCalendarSubscriptionAdded: "Subscribed!",
        calendarRemoved: "Google Calendar Removed",
        selectCalendarDetail: "Add new Calendar(s)",
        selectPendingCalendar: "Select Calendar",
        googleCalendarAddTagHeader: "Default Tag(s)",
        googleCalendarTags: "Tags",
        selectTagDetail: "These tags will be applied by default to the time records created for Google Calendar events. If a keyword tag is applied, default tags will not be applied to the time record. (Required for shared teams)",
        allDayEventsLabel: "Create time records for all day events",
        createForMembersLabel: "Create Time Records for team members who attend meetings on Connected Calendars",
        createForMembersDetail: "If checked, Shoutbase will create time records for yourself as well as your team members who are invited to Google Calendar events. If unchecked, only you will have time records created.",
        googleCalendarOverview: "Shoutbase can automatically create time records for your Google Calendar events. ",
        zoomHeader: "Zoom",
        zoomAddNew: "Add New Zoom Configuration",
        zoomOverview: "Shoutbase can automatically create time records for your Zoom meetings. ",
        connectToZoom: "Connect to Zoom",
    },
    teamModalSearch: {
        validEmail: "Please specify a valid email.",
    },
    reportModal: {
        exportString: "Export",
        downloadCsvString: "Download .CSV",
        pushToZapierString: "Push to Zapier",
    },
}



// WEBPACK FOOTER //
// ./src/common/strings/app_strings.js